import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";
import { StepNavigationBarWrapper } from "./StepNavigationBarWrapper";
import { StepNavigationBarRestartButton } from "./StepNavigationBarRestartButton";
import { SwarovskiButton } from "../../_shared-components/ui-elements/SwarovskiButton";
import { CSS_MQ } from "../../../styles/breakpoints";
import cn from "classnames";
import { LeftArrowSvg, RightArrowSvg } from "../../../assets";
import { type GuidedSellingTranslation } from "@swo/storefront";
import { T } from "../../T";

export const StepNavigationBar: ReactTFC<{
  onClickPrevious: undefined | (() => void);
  onClickRestart: () => void;
  onClickNext: undefined | (() => void);
  translations: GuidedSellingTranslation;
  firstSelection: string | undefined;
}> = props => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (props.firstSelection) {
      const { current } = buttonRef;

      if (current) {
        current.classList.remove("triggered");

        window.requestAnimationFrame(() =>
          window.requestAnimationFrame(() => {
            if (buttonRef.current) {
              buttonRef.current.classList.add("triggered");
            }
          }),
        );
      }
    }
  }, [props.firstSelection]);

  return (
    <StepNavigationBarWrapper>
      <StepNavigationBarRestartButton
        onClickRestart={props.onClickRestart}
        isDisabled={typeof props.onClickPrevious === "undefined"}
        translations={props.translations}
      />

      <div
        css={css`
          display: grid;
          align-items: center;
          grid-gap: 5px;
          grid-auto-flow: column;
          align-content: center;

          .label {
            ${CSS_MQ.atMostXs} {
              font-size: 16px;
            }
          }

          @keyframes subtle-wiggle {
            0% {
              transform: translateX(0);
            }

            50% {
              transform: translateX(4px);
            }

            100% {
              transform: translateX(0);
            }
          }

          ._button-next.triggered {
            animation-name: subtle-wiggle;
            animation-duration: 0.4s;
            animation-direction: normal;
            animation-timing-function: ease-out;
            animation-iteration-count: 2;
          }
        `}
      >
        <SwarovskiButton
          onClick={props.onClickPrevious}
          disabled={typeof props.onClickPrevious === "undefined"}
          as={"button"}
          variant={"ghost-underline"}
          size={"tiny"}
          Icon={<LeftArrowSvg />}
          iconPosition={"left"}
          className={"back"}
        >
          <span className={"label"}>
            <T>{props.translations["component_guided_selling.back"]}</T>
          </span>
        </SwarovskiButton>

        <SwarovskiButton
          ref={buttonRef}
          onClick={props.onClickNext}
          disabled={typeof props.onClickNext === "undefined"}
          className={cn("_button-next")}
          as={"button"}
          variant={"green"}
          size={"tiny"}
          Icon={<RightArrowSvg />}
          iconPosition={"right"}
        >
          <span className={"label"}>
            <T>{props.translations.next}</T>
          </span>
        </SwarovskiButton>
      </div>
    </StepNavigationBarWrapper>
  );
};
